export const initJiraFeedback = () => {
    let t = document.createElement('script');
    t.type = 'text/javascript';
    t.src =
        'https://weezevent.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/1kwsvv/b/9/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=2b751ea6';
    let n = document.getElementsByTagName('script')[0];
    n.parentNode.insertBefore(t, n);
};
